import PropTypes from 'prop-types';

const icons = PropTypes.oneOf([
  '',
  'add_circle',
  'settings',
  'publish',
  'person',
  'email',
  'input',
  'keyboard_arrow_left',
  'keyboard_arrow_right',
  'first_page',
  'last_page',
  'assignment_returned',
  'more_vert',
  'lock_open',
  'lock',
  'vertical_align_top',
  'business_center',
  'not_interested',
  'cancel',
]);

export default icons;



// WEBPACK FOOTER //
// ./src/constants/icons.js